// @flow

import { Component } from 'react';

import Styles from 'web-ssr/app/common/components/ContentHeader/HeaderBlock.scss';

import type { Node } from 'react';

const getBodyElement = () => {
  // `document` does not exist in SSR, so avoid interacting with this
  // API if this is performed on the server.
  if (!document) {
    return null;
  }

  return document.querySelector('body');
};

type Props = {
  onMount?: () => void,
  children: ({
    onHideMenu: () => void,
    onRevealMenu: () => void,
    onToggleMenu: () => void,
    onOpenServiceSearch: () => void,
    onCloseServiceSearch: () => void,
    isMenuVisible: boolean,
    isServiceSearchVisible: boolean,
  }) => Node,
};

type State = {
  isMenuVisible: boolean,
  isServiceSearchVisible: boolean,
};

class StatefulHeader extends Component<Props, State> {
  state = {
    isMenuVisible: false,
    isServiceSearchVisible: false,
  };

  UNSAFE_componentWillMount() {
    const { onMount } = this.props;

    if (onMount) {
      onMount();
    }
  }

  onHideMenu = () => {
    const $body = getBodyElement();

    if ($body) {
      $body.classList.remove(Styles.headerMobileMenuOpenClass);
    }

    this.setState({
      isMenuVisible: false,
    });
  };

  onRevealMenu = () => {
    const $body = getBodyElement();

    if ($body) {
      $body.classList.add(Styles.headerMobileMenuOpenClass);
    }

    this.setState({
      isMenuVisible: true,
    });
  };

  onToggleMenu = () =>
    !this.state.isMenuVisible ? this.onRevealMenu() : this.onHideMenu();

  onOpenServiceSearch = () => {
    this.setState({
      isServiceSearchVisible: true,
    });
  };

  onCloseServiceSearch = () => {
    this.setState({
      isServiceSearchVisible: false,
    });
  };

  render() {
    const { children } = this.props;
    const { isMenuVisible, isServiceSearchVisible } = this.state;

    return children({
      onHideMenu: this.onHideMenu,
      onRevealMenu: this.onRevealMenu,
      onToggleMenu: this.onToggleMenu,
      onOpenServiceSearch: this.onOpenServiceSearch,
      onCloseServiceSearch: this.onCloseServiceSearch,
      isMenuVisible,
      isServiceSearchVisible,
    });
  }
}

export default StatefulHeader;
